import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/logo/activ.svg'
import _imports_1 from '@/assets/images/logo/kcell.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["alt"]
const _hoisted_5 = {
  key: 0,
  class: "header-control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("figure", {
        class: _normalizeClass(["header-logo", _ctx.logoPosition?.toLowerCase()])
      }, [
        (_ctx.brand?.toLowerCase() === 'activ')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_0,
              alt: _ctx.brand
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_1,
              alt: _ctx.brand
            }, null, 8, _hoisted_4))
      ], 2),
      (_ctx.surveyStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("label", {
              class: _normalizeClass(["control-item", { active: _ctx.curLang === 'RU' }])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "RU",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lang) = $event)),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changeLang('RU')), ["prevent"]))
              }, null, 512), [
                [_vModelRadio, _ctx.lang]
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "РУС", -1))
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["control-item", { active: _ctx.curLang === 'KK' }])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "KK",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lang) = $event)),
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.changeLang('KK')), ["prevent"]))
              }, null, 512), [
                [_vModelRadio, _ctx.lang]
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "КАЗ", -1))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}